"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}
/**
 * @description :: Filling an array with numbers
 * @param {Number} start :: The starting number
 * @param {Function} end :: Function that determinates the end
 * @param {Number} step :: The incremental step
 * @param {Array} array :: The array to fill
 * @return {Array} :: Array of generated numbers
 */


var fill = function fill(start, end) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var array = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  if (start > end) return array;
  array = [].concat(_toConsumableArray(array), [start]);
  var value = start + step; // if ((step >= 0 && start >= end) || (step <= 0 && start <= end)) throw Error('You created an infinite loop')

  return fill(value, end, step, array);
};

exports.default = fill;